import { CrudService, httpClient, type HttpClient } from '../core'
import { projectsEndpoints } from './projects.endpoints'
import { projectPageSchema, projectSchema, type ProjectCreateBody, type ProjectDto, type ProjectFilters, type ProjectUpdateBody } from './projects.schemas'

export class ProjectsService extends CrudService<ProjectDto, ProjectCreateBody, ProjectUpdateBody, ProjectFilters> {
  constructor(http: HttpClient = httpClient) {
    super(http, projectsEndpoints, { item: projectSchema, page: projectPageSchema })
  }
}

export const projectsService = new ProjectsService()
